import { getCaptchaProviderHandler } from "./captcha_provider_registry";

/** @returns promise that resolves when the captcha script has loaded */
export async function loadCaptcha(): Promise<void> {
  const handler = getCaptchaProviderHandler();
  if (handler !== undefined) {
    await handler.loadCaptcha();
  }
}

export async function captchaExecute(action: string): Promise<string | undefined> {
  const handler = getCaptchaProviderHandler();
  if (handler !== undefined) {
    return handler.captchaExecute(action);
  } else {
    return undefined;
  }
}
